import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetail from "@/pages/ServiceDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FreeTrial from "@/pages/FreeTrial";
import Process from "@/pages/Process";
import Portfolio from "@/pages/Portfolio";
import NotFound from "@/pages/NotFound";

import { AdminAuthProvider } from "@/admin/AuthContext";
import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/pages/AdminLogin";
import Overview from "@/admin/pages/Overview";
import LeadsPage from "@/admin/pages/LeadsPage";
import CampaignsPage from "@/admin/pages/CampaignsPage";
import TemplatesPage from "@/admin/pages/TemplatesPage";
import ContactsPage from "@/admin/pages/ContactsPage";
import FreeTrialsPage from "@/admin/pages/FreeTrialsPage";
import PortfolioAdmin from "@/admin/pages/PortfolioAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            {/* Admin (isolated layout, no public header/footer) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Overview />} />
              <Route path="leads" element={<LeadsPage />} />
              <Route path="campaigns" element={<CampaignsPage />} />
              <Route path="templates" element={<TemplatesPage />} />
              <Route path="contacts" element={<ContactsPage />} />
              <Route path="free-trials" element={<FreeTrialsPage />} />
              <Route path="portfolio" element={<PortfolioAdmin />} />
            </Route>

            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/process" element={<Process />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/free-trial" element={<FreeTrial />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
